import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Directory from "@/pages/Directory";
import StaffDetail from "@/pages/StaffDetail";
import ResetPassword from "@/pages/ResetPassword";
import { LoginGate } from "@/components/LoginGate";
import { Loader2 } from "lucide-react";

function Gate({ children }) {
  const { ready, isAuthed } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen bg-[#0A1F44] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-[#C0982E] animate-spin" />
      </div>
    );
  }
  if (!isAuthed) return <LoginGate />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Gate><Directory /></Gate>} />
            <Route path="/staff/:id" element={<Gate><StaffDetail /></Gate>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
